export default "/_next/static/assets/fonts/GoodOT-Bold.f09eb554092b8f3e13f47f61f54303c3.woff2";